export default __webpack_public_path__ + "cf4d773ee8f891c761ca1ad849ce2927.png";